module.exports = __webpack_public_path__ + "static/media/RCW-Animation.7c0d4b59.svg";